module.exports = __webpack_public_path__ + "img/thumbnail_WildBoar_j_leucistic.58611733.png";